import { IUser } from "services/types";
import { Link } from "react-router-dom";

import { FollowButton } from "./FollowButton";
import { UnfollowButton } from "./UnfollowButton";
import VerifiedUserIcon from "components/UI/VerifiedUserIcon";
import { routes } from "routes";

import DEFAULT_USERPIC from "components/icons/default_userpic.svg";

import "./FollowingItem.scss";

export const FollowingItem = (props: {
  user: IUser;
  followed: boolean;
  onFollow: (username: string) => void;
}): JSX.Element => {
  const userpic = props.user.profileImageUrl
    ?? DEFAULT_USERPIC;

  const onFollow = (): void => {
    props.onFollow(props.user.username);
  };

  return (
    <div className="item">
      <Link className="thumbnail" to={routes.user(props.user.username)}>
        <img src={userpic} alt="" />
      </Link>
      <div className="text">
        <div className="username">
          <Link to={routes.user(props.user.username)}>{props.user.name ?? props.user.username}</Link>
          {props.user.verified && <VerifiedUserIcon />}
        </div>
      </div>

      {props.followed && <UnfollowButton
        onClick={onFollow}
      />}

      {!props.followed && <FollowButton
        onClick={onFollow}
      />}
    </div>
  );
};
